import React from "react";
import { DragLayer } from "react-dnd";
import { Segment } from "semantic-ui-react";
const layerStyles = {
  position: "fixed",
  pointerEvents: "none",
  zIndex: 100,
  left: 0,
  top: 0,
  width: window.innerWidth / 2,
  height: "100%"
};

function getItemStyles(props) {
  const { currentOffset } = props;
  if (!currentOffset) {
    return {
      display: "none"
    };
  }

  const { x, y } = currentOffset;
  const transform = `translate(${x}px, ${y}px)`;
  return {
    transform: transform,
    WebkitTransform: transform
  };
}

class RoomDragPreview extends React.Component {
  render() {
    const { isDragging, transfer } = this.props;
    if (!isDragging) {
      return null;
    }

    return (
      <div style={layerStyles}>
        <div style={getItemStyles(this.props)}>
          <Segment.Group>
            {transfer.map(room => (
              <Segment key={room.roomId}>{room.name}</Segment>
            ))}
          </Segment.Group>
        </div>
      </div>
    );
  }
}

function collect(monitor) {
  return {
    item: monitor.getItem(),
    itemType: monitor.getItemType(),
    currentOffset: monitor.getSourceClientOffset(),
    isDragging: monitor.isDragging()
  };
}

export default DragLayer(collect)(RoomDragPreview);



// WEBPACK FOOTER //
// ./src/cleaning/schedule/roomPicker/components/RoomDragPreview.js